import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const serviceID = 'Baniuagagroup';
    const notificationTemplateID = 'template_x2e3roj';
    const autoReplyTemplateID = 'template_ig5lyd4';

    const templateParams = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      subject: formData.subject,
      reply_to: formData.email,
      time: new Date().toLocaleString()
    };

    console.log("Sending emails with params:", templateParams);

    // Send notification email to you
    const notificationPromise = window.emailjs.send(serviceID, notificationTemplateID, templateParams);

    // Send auto-reply email to user
    const autoReplyPromise = window.emailjs.send(serviceID, autoReplyTemplateID, templateParams);

    // Wait for both emails to send
    Promise.all([notificationPromise, autoReplyPromise])
      .then((results) => {
        console.log('Both emails sent successfully:', results);
        setSubmitStatus('success');
        setIsSubmitting(false);

        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });

        setTimeout(() => {
          setSubmitStatus(null);
        }, 5000);
      })
      .catch((error) => {
        console.error('Failed to send email:', error);
        setSubmitStatus('error');
        setIsSubmitting(false);

        setTimeout(() => {
          setSubmitStatus(null);
        }, 5000);
      });
  };
  
  return (
    <form 
      className="space-y-6"
      onSubmit={handleSubmit}
    >
      
      {submitStatus === 'success' && (
        <div className="bg-green-50 border-l-4 border-green-500 text-green-800 rounded-md p-4 mb-4 shadow-sm">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium">Thank you for your message! We'll get back to you soon.</p>
            </div>
          </div>
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div className="bg-red-50 border-l-4 border-red-500 text-red-800 rounded-md p-4 mb-4 shadow-sm">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium">There was an error sending your message. Please try again later.</p>
            </div>
          </div>
        </div>
      )}
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-neutral-700 mb-1">
            Full Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-brand-500 transition-all duration-200"
            placeholder="John Doe"
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-neutral-700 mb-1">
            Email Address
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-brand-500 transition-all duration-200"
            placeholder="your@email.com"
          />
        </div>
      </div>

      <div>
        <label htmlFor="subject" className="block text-sm font-medium text-neutral-700 mb-1">
          Subject
        </label>
        <input
          type="text"
          id="subject"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-brand-500 transition-all duration-200"
          placeholder="How can we help you?"
        />
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-medium text-neutral-700 mb-1">
          Message
        </label>
        <textarea
          id="message"
          name="message"
          rows="5"
          value={formData.message}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-brand-500 transition-all duration-200"
          placeholder="Please provide details about your inquiry..."
        ></textarea>
      </div>

      <div>
        <button
          type="submit"
          disabled={isSubmitting}
          className={`w-full ${
            isSubmitting ? 'bg-brand-400 cursor-not-allowed' : 'bg-brand-600 hover:bg-brand-700 shadow-lg hover:shadow-xl'
          } text-white font-medium py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:-translate-y-1 text-lg`}
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
      </div>
      
      <p className="text-neutral-500 text-xs text-center mt-4">
        By submitting this form, you agree to our{' '}
        <Link to="/privacy-policy" className="text-brand-600 hover:text-brand-700 underline">
          privacy policy
        </Link>
        {' '}and{' '}
        <Link to="/terms-of-service" className="text-brand-600 hover:text-brand-700 underline">
          terms of service
        </Link>.
      </p>
    </form>
  );
};

export default ContactForm;